import { func_file, isNotNullUndefined } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {

    function exportData(data) {
        // Set Header Names
        let headers = [["Account Code", "Old Sub Total", "Sub Total"]];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = data.map((rowDetail) => {
            return [
                (rowDetail?.AccountCode? rowDetail.AccountCode: ""),
                (isNotNullUndefined(rowDetail?.OldSubTotal)? rowDetail.OldSubTotal: ""),
                (isNotNullUndefined(rowDetail?.SubTotal)? rowDetail.SubTotal: ""),
            ]
        });

        func_file.generateFile_XLSX("Unposted Invoices Report", "Unposted Invoices", headers, rows, null, null, columnWidths);
    }

    return exportData;
}